import React from 'react'
import { format } from 'date-fns'
import { Modal, Button, Card } from 'react-bootstrap'
import { ArrowDown } from 'react-bootstrap-icons'

import { parseDateFromServer } from '../functions/dateHandling'

const ObjectHistoryModal = (props) => {

  const {
    show,
    title,
    objectHistory,
    nameOfField,
    nameOfNestedField,
    handleClose,
  } = props

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {objectHistory && objectHistory.map((historyEntry, index) => {
          return (
            <ObjectHistoryEntry
              key={historyEntry.url}
              objectHistory={objectHistory}
              historyEntry={historyEntry}
              index={index}
              nameOfField={nameOfField}
              nameOfNestedField={nameOfNestedField}
            />
          )
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}


const ObjectHistoryEntry = (props) => {
  const {
    objectHistory,
    historyEntry,
    index,
    nameOfField,
    nameOfNestedField,
  } = props


  const displayEntryValue = (object) => {
    const targetObject = getTargetObject(object)

    if (!targetObject) {
      return 'N/A'
    }

    const entryValue = targetObject[nameOfField]

    if (entryValue === undefined || entryValue === null) {
      return 'N/A'
    }

    if (entryValue === false) {
      return 'No'
    }

    if (entryValue === true) {
      return 'Yes'
    }

    if (typeof entryValue === 'number') {
      return entryValue
    }

    if (!isNaN(new Date(parseDateFromServer(entryValue)))) {
      return format(parseDateFromServer(entryValue), "MMMM d,  yyyy")
    }

    return entryValue
  }

  const getTargetObject = (object) => {
    if (nameOfNestedField && object && object[nameOfNestedField]) {
      return object[nameOfNestedField]
    } else if (object) {
      return object
    } else {
      return null
    }
  }


  const formatDate = (date) => {
    return date ? format(new Date(historyEntry.modified_date), "PPpp") : 'N/A'
  }

  const entryValue = displayEntryValue(historyEntry)

  const previousEntryValue = displayEntryValue(objectHistory[index + 1])

  if (index < objectHistory.length - 1 && entryValue === previousEntryValue) {
    return null
  }


  return (
    <>
      <Card>
        <Card.Body>
          {index === objectHistory.length - 1 ?
            <Card.Text>
              <p>
                <strong>Original Value</strong>: {entryValue}
              </p>

              <p>
                Created on {formatDate(historyEntry.created_date)}
              </p>
            </Card.Text>
            :
            <Card.Text>
              <p>
                <strong>Value</strong>: {entryValue}
              </p>

              <p>
                <strong>Previous Value</strong>: {previousEntryValue}
              </p>

              <p>
                Modified on {formatDate(historyEntry.modified_date)}
              </p>
            </Card.Text>
          }
        </Card.Body>
      </Card>

      {index === objectHistory.length - 1 ?
        null
        :
        <center>
          <ArrowDown />
        </center>
      }
    </>
  )
}

export default ObjectHistoryModal
